import React, { useState } from 'react';
import { Modal, Row, Col, Form, Input, Button, message } from 'antd';

const formItemLayout = {
    labelCol: { span: 0 },
    wrapperCol: { span: 24 },
    colon: true
};

const ChangePasswordModal = ({
    visible,
    onCancel,
    onComplete,
    requestServerPost,
    usertoken,
    user, // The user object {userid, username} for whom the password is changed
    currentPassword = "", // Optional, used if we know the current password (e.g. forced change flow)
    successTitle = 'New Password Created',
    successContent = 'Please login again with your new password',
    successOkText = 'Back to Login'
}) => {
    const [loading, setLoading] = useState(false);
    const [form] = Form.useForm();

    const onFormSubmit = (values) => {
        if (!user || !user.userid) {
            message.error("User information missing");
            return;
        }

        const { newpassword, oldpassword } = values;

        setLoading(true);

        const params = {
            userid: user.userid,
            username: user.username,
            oldpassword: oldpassword || currentPassword, // Use form value, fallback to prop
            password: newpassword
        };

        requestServerPost("change_password", params, {}, (response) => {
            setLoading(false);
            console.log("change_password response", response);

            if (response.data && response.data.status === "success") {
                // If it's a self-password change (implied if currentPassword was provided or context), 
                // we might show "Please login again". 
                // However, to make this reusable, we might want to check or just show a generic success if not specified.
                // For now, I'll keep the logic from login.js but make the text generic if it seems like an admin action?
                // Actually user asked for "as defined in login.js".
                // But blindly saying "Please login again" for admin is bad.

                // Let's stick to the login.js behavior BUT maybe check if we should show the confirm modal.
                // Login.js shows a confirm modal.

                Modal.confirm({
                    title: successTitle,
                    content: successContent,
                    okText: successOkText,
                    cancelButtonProps: { style: { display: 'none' } },
                    closable: false,
                    onOk: () => {
                        onComplete();
                    },
                });
            } else {
                setLoading(false); // Ensure loading is off on error
                message.error(response.data?.message || "Invalid Username or Password");
            }

        }, usertoken, {}, (error) => {
            setLoading(false); // Ensure loading is off on network error
            console.error("Change password error", error);
            message.error("Failed to change password. Please try again.");
        });
    }

    return (
        <Modal
            open={visible}
            footer={null}
            width={550}
            bodyStyle={{ padding: 0 }}
            onCancel={onCancel}
            destroyOnClose={true}
        >
            <Row style={{ width: "100%", height: "100%" }} justify="center">
                <Col span={24} style={{ padding: "40px" }}>
                    <div style={{ fontSize: 38, fontWeight: 400, lineHeight: "42px", width: "100%", textAlign: "center", margin: "0 0 24px 0" }}>
                        Create New Password
                    </div>
                    <Form
                        form={form}
                        name="change_password_form"
                        {...formItemLayout}
                        onFinish={onFormSubmit}
                        initialValues={{
                            oldpassword: currentPassword,
                            newpassword: "",
                            confirm_password: ""
                        }}
                    >
                        <Row style={{ width: "100%" }} justify="center">
                            <Col span={22} style={{ padding: "14px" }}>
                                <Form.Item
                                    label="Current Password"
                                    name="oldpassword"
                                    rules={[{ required: true, message: "Please enter your current password!" }]}
                                >
                                    <Input.Password autoComplete="new-password" placeholder="Current Password *" />
                                </Form.Item>
                                <Form.Item
                                    label="New Password"
                                    name="newpassword"
                                    rules={[{ required: true, message: "Please enter a new password!" }]}
                                >
                                    <Input.Password autoComplete="new-password" placeholder="New Password *" />
                                </Form.Item>
                                <Form.Item
                                    label="Confirm Password"
                                    name="confirm_password"
                                    rules={[
                                        { required: true, message: "Confirm password is required" },
                                        ({ getFieldValue }) => ({
                                            validator(_, value) {
                                                if (!value || getFieldValue("newpassword") === value) {
                                                    return Promise.resolve();
                                                }
                                                return Promise.reject(new Error("Passwords do not match!"));
                                            },
                                        }),
                                    ]}
                                >
                                    <Input.Password autoComplete="new-password" placeholder="Confirm Password *" />
                                </Form.Item>
                            </Col>

                            <Col span={24}>
                                <Form.Item wrapperCol={{ span: 12 }} justify="center" style={{ marginTop: "20px" }}>
                                    <Button loading={loading} type="primary" htmlType="submit" style={{ width: "100%" }}>
                                        Save
                                    </Button>
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                </Col>
            </Row>
        </Modal>
    );
}

export default ChangePasswordModal;
